import React, { useEffect, useLayoutEffect, useRef, useMemo } from 'react';

let instanceNumbers = 0;
export default function Dropdown({ id, attachTo, opened, items, ...options }) {

	const instanceNumber = useRef(null);
	const dropdownInstance = useRef(null);

	const dropdown =
		useLayoutEffect(() => {
			instanceNumber.current = instanceNumbers++;
		}, []);

	const elementToAttachTo = useMemo(() => {
		if(!attachTo) {
			return null;
		}
		return attachTo.current ? attachTo.current : attachTo;
	}, [attachTo]);


	useEffect(() => {
		if(!elementToAttachTo) {
			return;
		}
		try {
			M.Dropdown.init(elementToAttachTo, options);
		} catch(error) {
			console.error(error);
		}
		dropdownInstance.current = M.Dropdown.getInstance(elementToAttachTo);
	}, [elementToAttachTo]);

	useEffect(() => {

		if(opened && elementToAttachTo) {
			dropdownInstance.current.open();
		} else {
		}

	}, [opened, elementToAttachTo]);

	function onClick(item, event) {
		console.log('wht is this', item);
		if(event) {
			console.log('the event', event.target, event.currentTarget);
		}
		item.onClick();
	}

	return (
		<ul
			id={id}
			className='dropdown-content'
		>
			{items.map((item, index) => {
				if(item === false){
					return null;
				}
				if(item.divider) {
					return <li
						key={index}
						className='divider' tabIndex='-1' />;
				}
				// A disabled item is shown, with its `title` saying why, and does nothing.
				if(item.disabled) {
					return (
						<li key={index} className='disabled' aria-disabled='true' title={item.title}>
							<a>{item.content}</a>
						</li>
					);
				}
				return (
					<li
						key={index}
						onClick={onClick.bind(null, item)}
					>
						<a>{item.content}</a>
					</li>
				);
			})}
		</ul>
	);
}